import { gql } from 'graphql-request'

import { GenericBlock } from './generic'

export const collectibleProgressFragment = gql`
  fragment collectibleProgressFragment on CollectibleProgress {
    id
    collectible {
      id
    }
  }
`

export interface CollectibleProgress extends GenericBlock<'CollectibleProgress'> {
  id: string
  collectible: {
    id: string
  }
}
